<template>
  <div class="p-error">
    <h1 class="p-error__heading">
      {{ pageTitle }}
    </h1>
    <section id="content" class="p-error__content" data-testid="error-page">
      <RichText :content="content" :content-type="'markdown'" />
      <ListOfLinks :key="links.length" :links="links" />
      <ImageAndCaption
        v-bind="{ ...item }"
        :key="item.id"
        :image-alt="item.imageAlt"
      />
    </section>
  </div>
</template>

<script>
import {
  useLocalization,
  ImageAndCaption,
  RichText,
  ListOfLinks
} from "@thegetty-private/getty-ui";
import errorPageContent from "@/data/error_page.md?raw";
import { useHead } from "@unhead/vue";

export default {
  name: "ErrorPage",
  components: { RichText, ListOfLinks, ImageAndCaption },
  inject: ["updatePageTitle"],
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      pageTitle: this.translatePart("error.page_title"),
      content: errorPageContent,
      item: {
        hasCaption: false,
        heading: "The Vexed Man",
        subheading: "Franz Xaver Messerschmidt",
        imageUuid: "fcda8c53-b7b7-41ed-83ff-eacb7ae16806",
        imageAlt: "The Vexed Man",
        to: {
          name: "object",
          params: {
            slug: "103QTJ"
          },
          state: {
            indexedId: "object/7408ddd3-0776-4afd-9452-0069e8f5e475",
            slug: "103QTJ"
          }
        },
        variableImageHeight: true
      }
    };
  },
  computed: {
    links() {
      return [
        {
          text: this.translatePart("error.links.search"),
          ariaLabel: this.translatePart("error.links.search_aria"),
          to: { name: "search" }
        },
        {
          text: this.translatePart("error.links.home"),
          ariaLabel: this.translatePart("error.links.home_aria"),
          url: "https://www.getty.edu"
        },
        {
          text: this.translatePart("error.links.contact"),
          ariaLabel: this.translatePart("error.links.contact_aria"),

          url: "https://www.getty.edu/about/contact_us.html"
        }
      ];
    }
  },
  mounted() {
    this.updatePageTitle(this.pageTitle);

    useHead({
      title: this.pageTitle,
      meta: [{ name: "robots", content: "none" }]
    });
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
